/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PointsStrictHttpResponse } from '../../points-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeaderboardModel } from '../../models/leaderboard-model';

export interface ConsumerLeaderboardGet$Params {

/**
 * The number of top scores to return (default: 5).
 */
  topCount?: number;
}

export function consumerLeaderboardGet(http: HttpClient, rootUrl: string, params?: ConsumerLeaderboardGet$Params, context?: HttpContext): Observable<PointsStrictHttpResponse<LeaderboardModel>> {
  const rb = new RequestBuilder(rootUrl, consumerLeaderboardGet.PATH, 'get');
  if (params) {
    rb.query('topCount', params.topCount, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PointsStrictHttpResponse<LeaderboardModel>;
    })
  );
}

consumerLeaderboardGet.PATH = '/Consumer/Leaderboard';
